import { createActions, createReducer } from 'reduxsauce'

import ObjetivoEstrategicoIndicadoresService from '../servicos/ObjetivoEstrategicoIndicadoresService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaObjetivoEstrategicoInicio: [],
    buscaObjetivoEstrategicoSucesso: ['objetivoEstrategico'],
    buscaObjetivoEstrategicoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaObjetivoEstrategico = () => {
    return dispatch => {
        dispatch(Creators.buscaObjetivoEstrategicoInicio())
        let serv = new ObjetivoEstrategicoIndicadoresService()
        return serv
            .getObjetivoEstrategico()
            .then(response => dispatch(Creators.buscaObjetivoEstrategicoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaObjetivoEstrategicoErro(error)))
    }
}

const buscaObjetivoEstrategicoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaObjetivoEstrategicoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaObjetivoEstrategicoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.objetivoEstrategico, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_OBJETIVO_ESTRATEGICO_INICIO]: buscaObjetivoEstrategicoInicio,
    [Types.BUSCA_OBJETIVO_ESTRATEGICO_ERRO]: buscaObjetivoEstrategicoErro,
    [Types.BUSCA_OBJETIVO_ESTRATEGICO_SUCESSO]: buscaObjetivoEstrategicoSucesso,
})
